var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBotaoAltoContraste(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 23,
    viewBox: "0 0 20 23",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "",
    stroke: "none",
    fill: "#1854b4",
    fillRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M 4.455 6.455 C -0.506 11.415, 3.009 20, 10 20 C 11.948 20, 13.998 19.093, 15.545 17.545 C 17.093 15.998, 18 13.948, 18 12 C 18 10.052, 17.093 8.002, 15.545 6.455 C 13.998 4.907, 11.948 4, 10 4 C 8.052 4, 6.002 4.907, 4.455 6.455 M 10 12 C 10 17.111, 11.245 18.355, 13.800 15.800 C 16.392 13.208, 14.628 7, 11.300 7 C 10.407 7, 10 8.564, 10 12",
    stroke: "none",
    fill: "#1454b4",
    fillRule: "evenodd"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBotaoAltoContraste);
export default __webpack_public_path__ + "static/media/BotaoAltoContraste.e44ec59266290776fffcea66b219ec7f.svg";
export { ForwardRef as ReactComponent };